import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'
import { withTableController } from 'shared/hooks'
import { ServicesContext } from 'services/context'

import { StoreContext } from 'store/context'
import { createColumns } from './columns.description'
import AthletesOverviewComponent from './component'

export const AthletesOverview = combine(
  withTableController({ id: 'athletes-table' }),
  withContext(
    'adminAthletesService',
    ServicesContext,
    ({ adminAthletesService }) => adminAthletesService
  ),
  withContext('appStore', StoreContext),
  withMemo('columns', () => createColumns(), []),
  withCallbacks(
    {
      loadAthletes:
        ({ appStore }) =>
        (tableState, _table, query) => {
          return appStore.adminAthletes.loadAthletes({
            name: query?.athletesName,
            sportType: query?.sportTypes,
            page: tableState.page,
            size: tableState.pageSize,
          })
        },

      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(AthletesOverviewComponent)
